import { createContext, useReducer, useEffect, ReactNode, Dispatch } from "react";
import { Year } from "../types";

export interface YearContextType {
    current: Year | undefined;
    dispatch: Dispatch<YearAction>;
}

export interface YearAction {
    type: 'SET';
    payload: Year;
}

export const YearContext = createContext<YearContextType | undefined>(undefined);

export const yearReducer = (state: { current: Year | undefined }, action: YearAction): { current: Year | undefined } => {
    switch (action.type) {
        case 'SET':
            return { current: action.payload };
        default:
            return state;
    }
};

interface YearContextProviderProps {
    children: ReactNode;
}

export const YearContextProvider = ({ children }: YearContextProviderProps) => {
    const [state, dispatch] = useReducer(yearReducer, {
        current: undefined
    });

    useEffect(() => {
        const fetchYear = async () => {
            const res = await fetch(`${process.env.REACT_APP_PATH}/api/year/current`);

            const json = await res.json();

            if (res.ok) {
                dispatch({ type: 'SET', payload: json[0] });
            }
        };

        fetchYear();
    }, []);

    return (
        <YearContext.Provider value={{ ...state, dispatch }}>
            {children}
        </YearContext.Provider>
    );
};
